import { useFeature, useViewerRoles } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import Checkpoints from './Checkpoints';
import InboxPersonalInformation from './InboxPersonalInformation';

const WORKSPACE_CHECKPOINTS = [
	{
		checkpoint: 'workspace.settings.theme',
		url: '/settings/theme',
	},
	{
		checkpoint: 'organization.goals',
		url: '/organization/goals',
	},
	{
		checkpoint: 'workspace.settings.jobTitles',
		url: '/settings/jobs/titles/new',
	},
	{
		checkpoint: 'workspace.departments.create',
		url: '/settings/departments',
	},
	{
		checkpoint: 'workspace.users.create',
		url: '/employees',
	},
	{
		checkpoint: 'workspace.learningEvents.create',
		url: '/learning/event/create',
	},
];

export function useShowInboxCheckpoints() {
	const roles = useViewerRoles();
	const showCheckpoints = useFeature(graphql.FeatureName.Checkpoints);

	return roles.isWorkspaceSuperuser && showCheckpoints;
}

export function InboxPersonalCheckpoints() {
	const showCheckpoints = useShowInboxCheckpoints();

	if (!showCheckpoints) {
		return null;
	}

	return <Checkpoints checkpoints={WORKSPACE_CHECKPOINTS} />;
}

export default function InboxPersonalSidebar() {
	return <InboxPersonalInformation />;
}
